export interface ICPLoader {
  cpLoader: boolean;
  cpLoaderModal: boolean;
  cpLoaderSize: string;
  message: string;
  fullScreen: boolean;
  customCss: string;
  cpLoaderOn(modal?: boolean, size?: string);
  cpLoaderOff();
}

export function UseCPLoader(): ClassDecorator {
  return function <T extends Function>(target: T) {
    Object.assign(target.prototype, {
      cpLoader: false,
      cpLoaderModal: false,
      cpLoaderSize: 'md',
      cpLoaderOn(modal: boolean = false, size: string = 'md') {
        this.cpLoaderSize = size;
        this.cpLoaderModal = modal;
        this.cpLoader = true;
      },
      cpLoaderOff() {
        this.cpLoader = false;
        this.cpLoaderModal = false;
      }
    });
  };
}

